import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  rolePermissions: any;
  employeesType: string;
}

const initialState: AuthState = {
  rolePermissions: [],
  employeesType: "0"
}; 

const rolePermissionsSlice = createSlice({
  name: 'rolePermissions',
  initialState,
  reducers: {
    setRolePermissions: (state, action: PayloadAction<any>) => {
      state.rolePermissions = action.payload;
    },
    clearRolePermissions: state => {
      state.rolePermissions = [];
    },
    setEmployeesType: (state, action: PayloadAction<string>) => {
      state.employeesType = action.payload;
    }
  },
});

export const { setRolePermissions, clearRolePermissions, setEmployeesType } = rolePermissionsSlice.actions;
export default rolePermissionsSlice.reducer;
